import React from 'react';

import TaraHeader from './TaraHeader';

const TaraIntroMessageResults = ({ queryText, length }) => (
  <div>
    <div>Hi there!</div>
    <div>
      <span>I'm </span>
      <strong>TARA</strong>
      <span>, and I'm your AI powered assistant for locating the best tickets for you.</span>
    </div>
    <div>
      <span>I&apos;ve found {length} {length === 1 ? 'event' : 'events'} for </span>
      <strong>&#8220;{queryText.toUpperCase()}&#8221;</strong>
      <span>. Pick a game below to get started!</span>
    </div>
  </div>
);

const TaraIntroMessageNoResults = ({ queryText }) => (
  <div>
    <div>Hi there!</div>
    <div>
      <span>I'm </span>
      <strong>TARA</strong>
      <span>, and I'm your AI powered assistant for locating the best tickets for you. </span>
    </div>
    <div>
      <span>I couldn&apos;t find anything for </span>
      <strong>&#8220;{queryText.toUpperCase()}&#8221;</strong>
      <span>, try search again!</span>
    </div>
  </div>
);

const TaraMessageResults = ({ queryText, length }) => (
  <div>
    <div>
      <span>I&apos;ve found {length} {length === 1 ? 'event' : 'events'} for </span>
      <strong>&#8220;{queryText.toUpperCase()}&#8221;</strong>
      <span>.</span>
    </div>
    <div>Pick a game below to get started!</div>
  </div>
);

const TaraMessageNoResults = ({ queryText }) => (
  <div>
    <div>
      <span>I couldn&apos;t find any events for </span>
      <strong>&#8220;{queryText.toUpperCase()}&#8221;</strong>
      <span>.</span>
    </div>
    <div>Try search again!</div>
  </div>
);

const TaraMessageFetching = ({ queryText }) => (
  <div>
    <div>
      <span>Searching for </span>
      <strong>&#8220;{queryText.toUpperCase()}&#8221;</strong>
      <span>&hellip;</span>
    </div>
  </div>
);

class TaraSearchHeader extends React.PureComponent {
  getTaraMessage() {
    const { queryText, isFetching } = this.props;
    const { length } = this.props.searchResults;

    const props = { queryText, length };

    if (isFetching) {
      return (<TaraMessageFetching {...props} />);
    }

    if (this.props.hasMadeIntroduction) {
      return !!length ? (<TaraMessageResults {...props} />) : (<TaraMessageNoResults {...props} />);
    }

    return !!length ? (<TaraIntroMessageResults {...props} />) : (<TaraIntroMessageNoResults {...props} />);
  }

  render() {
    return (
      <TaraHeader
        message={this.getTaraMessage()}
        style={{
          marginTop: 16,
          marginBottom: 16,
        }}
      />
    );
  }
}

export default TaraSearchHeader;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraSearchHeader.js